import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  LineItemInterface2ct3y0vtnbxod as LineItemInterface,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
} from '../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { sortedWith2csnbbb21k0lg as sortedWith } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  ChangeType_New_getInstance3fouji82nef8w as ChangeType_New_getInstance,
  ChangeType_Modify_getInstance2320ide7eqjcd as ChangeType_Modify_getInstance,
  ChangeType_Remove_getInstance2qh3m0yr0lh4w as ChangeType_Remove_getInstance,
} from '../../../../crowpay-shared/com/crowpay/enums.mjs';
import { LineItemHistory34tsqqs4wiqdw as LineItemHistory } from '../../../../crowpay-shared/com/crowpay/completionResponse/CompletionFlowPermissions.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/HasId.mjs';
import { ReadByDataModel1nk4gz5mxza5s as ReadByDataModel } from '../../../../crowpay-shared/com/crowpay/readReceipts.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.efy_1 = function_0;
      }
      wi(a, b) {
        return this.efy_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.efy_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var AdjustedLineItem$original$1Class;
function AdjustedLineItem$original$1() {
  if (AdjustedLineItem$original$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.ffy_1 = this$0.hf9_1;
        this.gfy_1 = this$0.hf9_1.n6k_1;
      }
      v91() {
        return this.gfy_1;
      }
      k20() {
        return this.ffy_1.l6k_1;
      }
      q91() {
        return this.ffy_1.m6k_1;
      }
      r91() {
        return this.ffy_1.p6k_1;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [LineItemInterface()]);
    AdjustedLineItem$original$1Class = $;
  }
  return AdjustedLineItem$original$1Class;
}
function AdjustedLineItem$changes$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.f6b_1;
  var tmp$ret$1 = a.f6b_1;
  return compareValues(tmp, tmp$ret$1);
}
var AdjustedLineItemClass;
function AdjustedLineItem() {
  if (AdjustedLineItemClass === VOID) {
    class $ {
      static hfy(wraps, changes) {
        var $this = createThis(this);
        $this.hf9_1 = wraps;
        var tmp = $this;
        tmp.if9_1 = new (AdjustedLineItem$original$1())($this);
        var tmp_0 = $this;
        // Inline function 'kotlin.collections.sortedByDescending' call
        // Inline function 'kotlin.comparisons.compareByDescending' call
        var tmp_1 = AdjustedLineItem$changes$lambda;
        var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp_1);
        tmp_0.jf9_1 = sortedWith(changes, tmp$ret$0);
        $this.kf9_1 = $this.hf9_1.g6k_1;
        $this.lf9_1 = $this.hf9_1.l6k_1;
        $this.mf9_1 = $this.hf9_1.p6k_1;
        var tmp_2 = $this;
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = changes.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!(element.c6b_1 == null)) {
              tmp$ret$3 = element;
              break $l$block;
            }
          }
          tmp$ret$3 = null;
        }
        var tmp0_safe_receiver = tmp$ret$3;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c6b_1;
        tmp_2.nf9_1 = tmp1_elvis_lhs == null ? $this.hf9_1.m6k_1 : tmp1_elvis_lhs;
        var tmp_3 = $this;
        var tmp_4;
        if (!($this.hf9_1.a6l_1 == null)) {
          tmp_4 = true;
        } else {
          var tmp$ret$4;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var tmp_5;
            if (isInterface(changes, Collection())) {
              tmp_5 = changes.i1();
            } else {
              tmp_5 = false;
            }
            if (tmp_5) {
              tmp$ret$4 = false;
              break $l$block_1;
            }
            var _iterator__ex2g4s_0 = changes.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              if (element_0.e6b_1) {
                tmp$ret$4 = true;
                break $l$block_1;
              }
            }
            tmp$ret$4 = false;
          }
          tmp_4 = tmp$ret$4;
        }
        tmp_3.of9_1 = tmp_4;
        return $this;
      }
      static ify(wraps) {
        return this.hfy(wraps, emptyList());
      }
      h40() {
        return this.kf9_1;
      }
      k20() {
        return this.lf9_1;
      }
      r91() {
        return this.mf9_1;
      }
      q91() {
        return this.nf9_1;
      }
      v91() {
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var this_0 = this.jf9_1;
        var sum = Companion_instance.p91(0n);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp = sum;
          var tmp0_elvis_lhs = element.d6b_1;
          var tmp_0;
          var tmp_1 = tmp0_elvis_lhs;
          if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
            tmp_0 = Companion_instance.p91(0n);
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var tmp$ret$0 = tmp_0;
          sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$0);
        }
        var tmp$ret$1 = sum;
        var tmp_2 = MonetaryValue__plus_impl_c1ylt(this.hf9_1.n6k_1, tmp$ret$1);
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var this_1 = this.hf9_1.x6k_1;
        var sum_0 = Companion_instance.p91(0n);
        var _iterator__ex2g4s_0 = this_1.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          var tmp_3 = sum_0;
          var tmp$ret$2 = element_0.a5r_1;
          sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_3, tmp$ret$2);
        }
        var tmp$ret$3 = sum_0;
        return MonetaryValue__minus_impl_jw9qyp(tmp_2, tmp$ret$3);
      }
      jfy() {
        return this.hf9_1.h6k_1;
      }
      kfy() {
        return this.hf9_1.r6k_1;
      }
      lfy() {
        return this.hf9_1.q6k_1;
      }
      mfy() {
        return this.hf9_1.y6k_1;
      }
      nfy() {
        return this.hf9_1.j6k_1;
      }
      e99() {
        return this.hf9_1.k6k_1;
      }
      q94() {
        return this.hf9_1.i6k_1;
      }
      y91() {
        return this.hf9_1.y91();
      }
      ofy() {
        return this.hf9_1.c6l_1;
      }
      pfy() {
        return this.hf9_1.t6k_1;
      }
      qfy() {
        return this.hf9_1.u6k_1;
      }
      z94() {
        var tmp;
        if (this.of9_1) {
          tmp = ChangeType_Remove_getInstance();
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.jf9_1.i1()) {
            tmp = ChangeType_Modify_getInstance();
          } else {
            if (!(this.hf9_1.i6k_1 == null)) {
              tmp = ChangeType_New_getInstance();
            } else {
              tmp = null;
            }
          }
        }
        return tmp;
      }
      rfy(state) {
        return AdjustedLineItem().hfy(this.hf9_1.i6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, state), this.jf9_1);
      }
      sfy(time, history, inPreSubstantialCompletion) {
        var tmp;
        if (this.hf9_1.b6l_1.y26(time) > 0) {
          tmp = null;
        } else {
          var tmp1_$this = this.hf9_1;
          var tmp0_safe_receiver = this.hf9_1.y6k_1;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.takeUnless' call
            var tmp_1;
            if (!(tmp0_safe_receiver.q54_1.y26(time) > 0)) {
              tmp_1 = tmp0_safe_receiver;
            } else {
              tmp_1 = null;
            }
            tmp_0 = tmp_1;
          }
          var tmp2_complete = tmp_0;
          var tmp3_state = LineItemHistory().w8w(this.hf9_1, history, inPreSubstantialCompletion).h8x();
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = this.hf9_1.x6k_1;
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.b5r_1.y26(time) <= 0) {
              destination.v(element);
            }
          }
          var tmp_2 = tmp1_$this.i6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp3_state, VOID, VOID, VOID, VOID, VOID, destination, tmp2_complete);
          // Inline function 'kotlin.collections.filter' call
          var tmp0_0 = this.jf9_1;
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = tmp0_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (element_0.f6b_1.y26(time) < 0) {
              destination_0.v(element_0);
            }
          }
          tmp = AdjustedLineItem().hfy(tmp_2, destination_0);
        }
        return tmp;
      }
      t91() {
        return this.hf9_1.d6l_1;
      }
    }
    initMetadataForClass($, 'AdjustedLineItem', VOID, VOID, [LineItemInterface(), HasId(), ReadByDataModel()]);
    AdjustedLineItemClass = $;
  }
  return AdjustedLineItemClass;
}
function get_increasedProjectPrice(_this__u8e3s4) {
  return MonetaryValue__compareTo_impl_w7ul1r(_this__u8e3s4.s6k_1, Companion_instance.p91(0n)) > 0 || !(_this__u8e3s4.i6k_1 == null);
}
//region block: exports
export {
  AdjustedLineItem as AdjustedLineItemjcq04uf63gb9,
  get_increasedProjectPrice as get_increasedProjectPricecnanfo88a7j2,
};
//endregion

//# sourceMappingURL=AdjustedLineItem.mjs.map
